import { gql } from '@apollo/client';

export const GET_UPCOMING_RACES_TEASER = gql`
  query GetUpcomingRacesTeaser($limit: Int = 2) {
    upcomingRacesTeaser(limit: $limit) {
      race_id
      race_number
      race_time
      meeting {
        track {
          code
          name
          state
        }
      }
    }
  }
`;
